/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Box, Heading, Paragraph } from "theme-ui";

export const query = graphql`
  fragment BulletListItemFragment on ContentfulBulletListItem {
    heading
    listItemMarkerImage {
      gatsbyImageData
      file {
        contentType
        url
      }
      description
    }
    listItems {
      content {
        content
      }
    }
  }
`;

const BulletListItem = ({ gridItem }) => {
  const { listItemMarkerImage, heading, listItems } = gridItem;

  return (
    <Box>
      <Heading>{heading}</Heading>
      <ul sx={{ mt: "56px", pl: "26px" }}>
        {listItems.map((listItem) => (
          <li
            key={listItem}
            sx={{
              listStyleImage:
                listItemMarkerImage && `url(${listItemMarkerImage.file.url})`,
              mb: "12px",
            }}
          >
            {listItem.content && (
              <Paragraph>{listItem.content.content}</Paragraph>
            )}
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default BulletListItem;
